import { DynamicStandaloneBlogSlider } from '@/components/BlogSlider';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorBlogSlider: LabradorComponent = ({ type, data, meta }) => {
  return (
    <DynamicStandaloneBlogSlider
      headline={data.title}
      bloggers={data.bloggers}
      options={data.options}
      data-content-index={meta.contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorBlogSlider;
